/* eslint-disable react/function-component-definition */
import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../../PrivateRoute';
import CruiseResultsPage from '../pages/CruiseResultsPage/CruiseResultsPage';
import CruiseDetailsPage from '../pages/CruiseDetailsPage/CruiseDetailsPage';
import CruiseCabinPage from '../pages/CruiseCabinPage/CruiseCabinPage';
import CruiseGuestsPage from '../pages/CruiseGuestsPage/CruiseGuestsPage';
import CruiseConfirmationPage from '../pages/CruiseConfirmationPage/CruiseConfirmationPage';
import { CRUISE_ROUTES } from '../constants/cruiseConstants';

/**
 * Route fragment for the cruise module. Search lives on the landing page
 * ("Cruises" tab).
 *
 * Usage from /src/AppRoutes.jsx (same pattern as PackageRoutes):
 *   {appConfig?.hasCruise && CruiseRoutes()}
 */
const PAGES = [
  [CRUISE_ROUTES.RESULTS, CruiseResultsPage],
  [CRUISE_ROUTES.DETAILS, CruiseDetailsPage],
  [CRUISE_ROUTES.CABIN, CruiseCabinPage],
  [CRUISE_ROUTES.GUESTS, CruiseGuestsPage],
  [CRUISE_ROUTES.CONFIRMATION, CruiseConfirmationPage],
];

const CruiseRoutes = () => (
  <>
    {PAGES.map(([path, Page]) => (
      <Route
        key={path}
        path={path}
        element={
          <PrivateRoute>
            <Page />
          </PrivateRoute>
        }
      />
    ))}
  </>
);

export default CruiseRoutes;
